import React, { memo, useCallback } from 'react';
import classNames from 'classnames';
import { AdvancedFilterResultsProps } from 'ducks/types/prop-types';
import { useSwitchTheme } from 'hooks/useSwitchTheme';
import { date_range } from 'modals/advanced-filtering/constants';
import { useFilterContext } from 'modals/advanced-filtering/context/FilterContext';

import cn from 'modals/advanced-filtering/components/AdvancedFilter.module.scss';

const AdvancedFilterResultsBase = ({
  date_range_select,
  max_results,
  onParseDate,
  onDropDownChange,
}: AdvancedFilterResultsProps) => {
  const { theme, is_dark_theme } = useSwitchTheme();
  const {
    form: { max_rows },
    onChange,
  } = useFilterContext();

  const onMaxRowsChange = useCallback(
    (value: number) => {
      onChange({ max_rows: value });
    },
    [onChange],
  );
  return (
    <>
      <h3 className={cn.filterResults} style={{ color: theme.font_color }}>
        Date Range
      </h3>
      <div className={cn.resultsFlex}>
        {date_range.map((el, id) => (
          <div
            key={el}
            onClick={() => {
              onParseDate(el);
              onDropDownChange(false);
            }}
            className={classNames(is_dark_theme ? cn.resultDark : cn.result, {
              [cn.active]: date_range_select === el,
            })}
            style={{ marginRight: id !== 3 ? '4px' : '0px', color: theme.font_color }}
          >
            {el}
          </div>
        ))}
      </div>
      <h3 className={cn.filterResults} style={{ color: theme.font_color }}>
        Max Results
      </h3>
      <div className={cn.resultsFlex}>
        {max_results.map((el, id) => (
          <div
            key={el.name}
            onClick={() => onMaxRowsChange(el.name)}
            className={classNames(is_dark_theme ? cn.resultDark : cn.result, {
              [cn.active]: max_rows === el.name,
            })}
            style={{ marginLeft: id !== 0 ? '4px' : '', color: theme.font_color }}
          >
            {el.name}
          </div>
        ))}
      </div>
    </>
  );
};

export const AdvancedFilterResults = memo(AdvancedFilterResultsBase);
